import React from "react";

const socialList = [
  {
    iconName: "socicon-linkedin",
    link: "https://www.linkedin.com/in/jmcancode/",
  },
  {
    iconName: "socicon-github",
    link: "https://github.com/jmcancode",
  },
  {
    iconName: "socicon-apple",
    link: "https://apps.apple.com/us/developer/jon-michael-narvaez/id1246305819",
  },
  {
    iconName: "socicon-android",
    link: "https://play.google.com/store/apps/dev?id=4967133014784023982",
  },
  {
    iconName: "socicon-facebook",
    link: "https://www.facebook.com/jonmichaelnarvaez",
  },
  {
    iconName: "socicon-instagram",
    link: "https://www.instagram.com/jonmichaelnarvaez",
  },
];

const SocialTwo = () => {
  return (
    <>
      {socialList.map((val, i) => (
        <a
          className="ptf-social-icon ptf-social-icon--style-1"
          target="_blank"
          rel="noopener noreferrer"
          href={val.link}
          key={i}
        >
          <i className={val.iconName}></i>
        </a>
      ))}
    </>
  );
};

export default SocialTwo;
